import { Building2, KeyRound, Pencil, Trash2 } from 'lucide-react';

function TableActionButtons({
  canView = false,
  canEdit = false,
  canDelete = false,
  canResetPassword = false,
  canToggle = false,
  onView,
  onEdit,
  onDelete,
  onResetPassword,
  onToggle,
  toggleStatus,
}) {
  const isActive = String(toggleStatus || '').toLowerCase() === 'active';

  return (
    <div className="flex items-center gap-3">
      {canView ? (
        <button
          className="rounded-md border border-[#d8d1ca] bg-white p-1.5 text-[#6f6258] transition hover:bg-[#faf7f3]"
          type="button"
          onClick={onView}
          title="Manage Branches"
        >
          <Building2 className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      ) : null}

      {canEdit ? (
        <button
          className="rounded-md bg-[#6f5644] p-1.5 text-white transition hover:bg-[#5f4a3b]"
          type="button"
          onClick={onEdit}
          title="Edit"
        >
          <Pencil className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      ) : null}

      {canResetPassword ? (
        <button
          className="rounded-md border border-[#d8d1ca] bg-white p-1.5 text-[#6f5644] transition hover:bg-[#faf7f3]"
          type="button"
          onClick={onResetPassword}
          title="Reset Password"
        >
          <KeyRound className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      ) : null}

      {canToggle ? (
        <button
          className={`relative inline-flex h-6 w-10 items-center rounded-full border transition ${
            isActive
              ? 'border-[#8e7663] bg-[#8e7663]'
              : 'border-[#d9d2cc] bg-[#efebe7]'
          }`}
          type="button"
          onClick={onToggle}
          title="Toggle Status"
          aria-label={`Set status to ${isActive ? 'inactive' : 'active'}`}
        >
          <span
            className={`inline-block h-4 w-4 rounded-full bg-white shadow-sm transition ${
              isActive ? 'translate-x-5' : 'translate-x-1'
            }`}
            aria-hidden="true"
          />
        </button>
      ) : null}

      {canDelete ? (
        <button
          className="text-red-500 transition hover:text-red-700"
          type="button"
          onClick={onDelete}
          title="Delete"
        >
          <Trash2 className="h-[18px] w-[18px]" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}

export default TableActionButtons;
